<template>
    <!-- FLANGE -->
    <div class="tab-pane fade show active" id="flangeIntegralCalculator">
        
        <!-- BOTÃO DESENHO DE APOIO -->
        <h5 class="text mt-5 text-primary">
            <b>Desenho de apoio</b>
        </h5>
        <div class="col-2">
            <button
            class="btn btn-secundario"
            @click="mostrarDesenho()"
            >
            Mostrar desenho
            </button>
        </div>
        <!-- POPUP COM O DESENHO -->
        <DesenhoApoio
        v-model="showDrawing"
        :tipo="6"
        />

        <h5 class="text mt-5 text-primary">
            <b> Calculation According To ASME VII Div.1
                (All Symbols According To Appendix 2)
                Integral Type Flanges – Fig. 2-4 (5), (6), (6a), (6b) And (7)
                Loose Type Flanges – Fig. 2-4 (1), (1a), (2), (2a), (3), (3a), (4) And (4a)
            </b>
        </h5>

        <form ref="formCalculo" @submit.prevent="calculos">

            <div class="form-group row">
                <div class="col-10">
                    <h5 class="text mt-5 text-primary text-start"><b>1. PRE-CONFIGURATION</b></h5>
                </div>
            </div>

            <div class="form-group row mt-3">
                <label for="overbolting" class="col-sm-6 col-form-label d-flex align-items-center flex-wrap">
                    <span class="me-2"><b>Shall it consider the maximum torch (overbolting)?</b></span>
                    <InterrogacaoHover text="Considera o torque máximo aplicado nos parafusos (over-tightening). No flange integral, isso aumenta significativamente os momentos fletores e as tensões no hub." />
                </label>
                <div class="col-sm-3">
                    <select id="overbolting" class="form-select" v-model="flangeIntegralCalculator.overboltingSelect" required>
                        <option value="">Selecione</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>

            <div class="form-group row mt-3">
                <label for="bSelect" class="col-sm-6 col-form-label d-flex align-items-center flex-wrap">
                    <span class="me-2"><b>Do you want to replace B per B1?</b></span>
                    <InterrogacaoHover text="Utiliza o diâmetro efetivo B1 no lugar de B quando há interferência geométrica do hub ou condições específicas da ASME Appendix 2." />
                </label>
                <div class="col-sm-3">
                    <select id="bSelect" class="form-select" v-model="flangeIntegralCalculator.bSelect" required>
                        <option value="">Selecione</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>2. FLANGE MATERIAL</b></h5>
                </div>
            </div>

            <!-- Flange Material -->
            <div class="table">

                <div class="table-responsive material-table">

                    <table class="table mt-5">
                        <thead>
                            <tr>
                                <th scope="col">DESIGN DATA</th>
                                <th scope="col"></th>
                                <th scope="col">VALUE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">
                                    <span><b>Flange Material</b></span>
                                    <InterrogacaoHover text="Material do flange integral. Define as tensões admissíveis Sfo (operação) e Sfa (ambiente), fundamentais para verificação de tensões no hub e na face do flange." />
                                </th>
                                <td></td>
                                <td>
                                    <!-- Container com posição relativa para conter a lista -->
                                    <div class="position-relative">
                                        <!-- BUSCA -->
                                        <div class="position-relative">
                                            <input
                                            type="search"
                                            class="form-control ps-5 input"
                                            placeholder="Buscar material"
                                            v-model="materialSearch"

                                            @focus="abrirListaMaterial"
                                            @click="abrirListaMaterial"
                                            @input="handleInput"
                                            @blur="fecharListaMaterial"
                                            required
                                            />

                                            <!-- ÍCONE LUPA -->
                                            <span
                                                class="position-absolute start-0 top-50 translate-middle-y ps-3"
                                            >
                                                <img src="@/views/img/search-icon.svg" width="16" />
                                            </span>
                                        </div>

                                        <!-- LISTA DE RESULTADOS - Agora dentro do container position-relative -->
                                        <ul
                                            v-if="mostrarListaMaterial && materiaisFiltrados.length"
                                            class="material-options list-group position-absolute w-100 mt-1"
                                        >
                                            <li
                                                class="material-option list-group-item list-group-item-action"
                                                v-for="(material, index) in materiaisFiltrados"
                                                :key="material.materialSpecification + index"
                                                @mousedown.prevent="selecionarMaterial(material)"
                                            >
                                                <b>{{ [material.materialSpecification, material.classConditionTemper].filter(Boolean).join(" ") }}</b>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span><b>Bolt Material</b></span>
                                    <InterrogacaoHover text="Material dos parafusos. Controla a capacidade de carga de aperto e influencia diretamente nas forças Wm1 e Wm2 e no momento total aplicado ao flange." />
                                </th>
                                <td></td>
                                <td>
                                    <select
                                        class="form-select"
                                        v-model="boltSelecionado"
                                        required
                                    >
                                        <option value="">Selecione</option>

                                        <option
                                            v-for="bolt in boltOptions"
                                            :key="bolt.name"
                                            :value="bolt"
                                        >
                                            {{ bolt.name }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span><b>Gasket Material</b></span>
                                    <InterrogacaoHover text="Material da junta. Define os fatores m (vedação sob pressão) e y (assentamento), que determinam as cargas mínimas de aperto." />
                                </th>
                                <td></td>
                                <td>
                                    <select
                                        class="form-select"
                                        v-model="gasketSelecionado"
                                        required
                                    >
                                        <option  value="">Selecione</option>

                                        <option
                                            v-for="gasket in gasketOptions"
                                            :key="gasket.name"
                                            :value="gasket"
                                        >
                                            {{ gasket.name }}
                                        </option>
                                    </select>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>

            </div>

            <!-- Design Data -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>3. DESIGN DATA</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">DESIGN DATA</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Design Pressure (Internal)</th>
                            <td>P</td>
                            <td>
                                {{ flangeIntegralCalculator.designPressureInternal }}
                            </td>
                            <td>Mpa</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Temperature</th>
                            <td>Tp</td>
                            <td>
                                {{ flangeIntegralCalculator.designTemperature }}
                            </td>
                            <td>ºC</td>
                        </tr>
                        <tr>
                            <th scope="row">Corrosion Allowance</th>
                            <td>c</td>
                            <td>
                                {{ flangeIntegralCalculator.corrosionAllowance }}
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">SHELL ALLOW. STRESS</th>
                            <td>Sn</td>
                            <td>
                                {{ flangeIntegralCalculator.shellAllowStress }}
                            </td>
                            <td>N/mm2</td>
                        </tr>
                    
                    </tbody>
                </table>
            
            </div>

            <!-- Flange Allow. Stress -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>4. FLANGE ALLOW. STRESS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">FLANGE ALLOW. STRESS</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">AT design temp</th>
                            <td>Sfo</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.sfo }}
                                </h6>
                            </td>
                            <td>N/mm2</td>
                        </tr>
                        <tr>
                            <th scope="row">AT atmospheric temp</th>
                            <td>Sfa</td>
                                <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.sfa }}
                                </h6>
                            </td>
                            <td>N/mm2</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Bolting Allow. Stress -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>5. BOLTING ALLOW. STRESS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">BOLTING ALLOW. STRESS</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">AT design temp</th>
                            <td>Sbo</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.sbo }}
                                </h6>
                            </td>
                            <td>N/mm2</td>
                        </tr>
                        <tr>
                            <th scope="row">AT atmospheric temp</th>
                            <td>Sba</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.sba }}
                                </h6>
                            </td>
                            <td>N/mm2</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Flange -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>6. FLANGE</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">FLANGE</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <span><b>OD Flange</b></span>
                                <InterrogacaoHover text="Diâmetro externo do flange. Influencia diretamente o fator geométrico K = A/B e os coeficientes de forma utilizados no cálculo de tensões." />
                            </th>
                            <td><b>A</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.odFlange" required /></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>ID Flange</b></span>
                                <InterrogacaoHover text="Diâmetro interno do flange. Base para cálculo de pressão interna, área carregada e momentos atuantes." />
                            </th>
                            <td><b>B</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.idFlange" required /></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Center bolt diameter</b></span>
                                <InterrogacaoHover text="Diâmetro do círculo de parafusos. Define o braço de alavanca das forças de aperto, impactando diretamente o momento no flange." />
                            </th>
                            <td><b>C</b></td>
                            <td><input type="text" class="form-control"
                                    v-model="flangeIntegralCalculator.centerBoltDiameter" required /></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Load reaction gasket diam.</th>
                            <td>G</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.loadReactionGasketDiameter }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>thk. of hub not corr. at small end</b></span>
                                <InterrogacaoHover text="Espessura do hub na extremidade menor (junção com o tubo), sem corrosão. Crítica para cálculo da tensão longitudinal SH." />
                            </th>
                            <td><b>g0</b></td>
                            <td><input type="text" class="form-control"
                                    v-model="flangeIntegralCalculator.thicknessHubSmallEnd" required /></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>thk. Hub not corr. At back of flange</b></span>
                                <InterrogacaoHover text="Espessura do hub na base do flange. Afeta a rigidez da conexão e distribuição das tensões de flexão." />
                            </th>
                            <td><b>g1</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.thicknessHubBack" required/></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Mensagem g1</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.mensagemG1 }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Hub length</b></span>
                                <InterrogacaoHover text="Comprimento do hub. Controla a flexibilidade do flange integral e influencia diretamente os coeficientes de forma (U, V, F)." />
                            </th>
                            <td><b>h</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.hubLength" required /></td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">R</th>
                            <td>R</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.R }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">f</th>
                            <td>f</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.f }}
                                </h6>
                            </td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">Mensagem f</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.mensagemF }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">B1</th>
                            <td>B1</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.b1 }}
                                </h6>
                            </td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">Mensagem B1</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.mensagemB1 }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">Largura Mínima da Junta</th>
                            <td>Nmin</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.larguraMinimaJunta }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Bolting -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>7. BOLTING</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">

                    <thead>
                        <tr>
                            <th scope="col">BOLTING</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>

                    <tbody>
                        
                        <tr>
                            <th scope="row">
                                <span><b>Bolt Diameter</b></span>
                                <InterrogacaoHover text="Diâmetro nominal do parafuso. Usado para calcular a área resistente e a capacidade de carga do conjunto de fixação." />
                            </th>
                            <td><b>d</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.boltDiameter" required /></td>
                            <td><b>in</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Pitch Diameter</b></span>
                                <InterrogacaoHover text="Passo da rosca do parafuso (threads per inch). Influencia diretamente a área resistente efetiva e a relação entre torque aplicado e força axial de aperto nos parafusos." />
                            </th>
                            <td><b>Dp</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.pitchDiameter" required /></td>
                            <td><b>fios/in</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Bolts Quantity</b></span>
                                <InterrogacaoHover text="Número total de parafusos no flange. Afeta a distribuição da carga de aperto e a área total resistente do conjunto de fixação." />
                            </th>
                            <td><b>n</b></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.boltsQuantity" required /></td>
                            <td><b>-</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Stress Area</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.rootDiameter }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Friction Factor</b></span>
                                <InterrogacaoHover text="Coeficiente de atrito entre rosca e face de apoio. Determina a relação entre torque aplicado e força real de aperto nos parafusos." />
                            </th>
                            <td></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.frictionFactor" required /></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">Minimum Torque</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.torqueMinimo }}
                                </h6>
                            </td>
                            <td>N.m</td>
                        </tr>
                        <tr>
                            <th scope="row">Maximum Torque</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.torqueMaximo }}
                                </h6>
                            </td>
                            <td>N.m</td>
                        </tr>
                        
                    </tbody>
                </table>

            </div>

            <!-- Gasket -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>8. GASKET</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">GASKET</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <span><b>OD Gasket</b></span>
                                <InterrogacaoHover text="Diâmetro externo da junta. Define o limite externo da área de vedação e influencia o diâmetro efetivo G utilizado nos cálculos." />
                            </th>
                            <td></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.odGasket" required /></td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>ID Gasket</b></span>
                                <InterrogacaoHover text="Diâmetro interno da junta. Define a área exposta à pressão interna e é utilizado no cálculo da largura efetiva da vedação." />
                            </th>
                            <td></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.idGasket" required /></td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Maximum Gasket Crushing Pressure</b></span>
                                <InterrogacaoHover text="Pressão máxima suportada pela junta antes de esmagamento. Limita a carga máxima aplicável durante o aperto." />
                            </th>
                            <td></td>
                            <td><input type="text" class="form-control" v-model="flangeIntegralCalculator.gasketCrushingPressure" required /></td>
                            <td>N/mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">Ag</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Ag }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">Sya</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Sya }}
                                </h6>
                            </td>
                            <td>N/mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">Sys</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Sys }}
                                </h6>
                            </td>
                            <td>N/mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">Max. Stress Gasket vs Max. Force W</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.valorCampoSemNome1 }}
                                </h6>
                            </td>
                            <td>{{flangeIntegralCalculator.unidadeCampoSemNome1}}</td>
                        </tr>
                        <tr>
                            <th scope="row">Max. Stress Gasket vs Max. Oper. force - Wm1</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.valorCampoSemNome2}}
                                </h6>
                            </td>
                            <td>{{flangeIntegralCalculator.unidadeCampoSemNome2}}</td>
                        </tr>
                        <tr>
                            <th scope="row">Gasket Assessment</th>
                            <td></td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.resultGasket }}
                                </h6>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- TABELA GRANDE -->

            <!-- Parameters N, b0, b, y, m -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>9. PARAMETERS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">PARAMETER</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">(od - id)/2</th>
                            <td>N</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.N }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">N/2</th>
                            <td>b0</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.b0 }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">min.(b0, 2.5√(b0*1/2))</th>
                            <td>b</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.b }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Gasket factor</b></span>
                                <InterrogacaoHover text="O valor pode ser inserido manualmente ou preenchido pela seleção da junta." />
                            </th>
                            <td>y</td>
                            <td>
                                <input
                                    type="number"
                                    step="any"
                                    class="form-control"
                                    v-model="flangeIntegralCalculator.y"
                                    required
                                />
                            </td>
                            <td>N/mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>m factor</b></span>
                                <InterrogacaoHover text="O valor pode ser inserido manualmente ou preenchido pela seleção da junta." />
                            </th>
                            <td>m</td>
                            <td>
                                <input
                                    type="number"
                                    step="any"
                                    class="form-control"
                                    v-model="flangeIntegralCalculator.m"
                                    required
                                />
                            </td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Additional Results -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>10. CALCULATED VALUES</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">DESCRIPTION</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">3,14 b Gy</th>
                            <td>Wm2</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Wm2 }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">6,28 b Gmp</th>
                            <td>Hp</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Hp }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">0,785 G² p</th>
                            <td>H</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.H }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">Hp + H</th>
                            <td>Wm1</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Wm1 }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">max(Wm2/Sba, Wm1/Sbo)</th>
                            <td>Am</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Am }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">bolts qty × root area</th>
                            <td>Ab</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Ab }}
                                </h6>
                            </td>
                            <td>mm²</td>
                        </tr>
                        <tr>
                            <th scope="row">(Am + Ab) Sba / 2</th>
                            <td>W1</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.W1 }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">(Ab × Sba)</th>
                            <td>W2</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.W2 }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">max(W1, W2)</th>
                            <td>W</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.W }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>

                    </tbody>
                </table>

            </div>

            <!-- Operating Conditions -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>11. OPERATING CONDITIONS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">FLANGE LOADS</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">0,785 B² P</th>
                            <td>Hd</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Hd }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">W - H</th>
                            <td>Hg</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Hg }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                        <tr>
                            <th scope="row">H - Hd</th>
                            <td>Ht</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Ht }}
                                </h6>
                            </td>
                            <td>N</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">LEVER ARMS</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">R + 0,5 g1</th>
                            <td>hd</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.hd }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">(C - G) / 2</th>
                            <td>hg</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.hg }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">(R + g1 + hg) / 2</th>
                            <td>ht</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.ht }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr style="width: 10px !important">
                            <th scope="col" class="col-symbol">FLANGE MOMENTS</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Hd × hd</th>
                            <td>Md</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Md }}
                                </h6>
                            </td>
                            <td>N·mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Hg × hg</th>
                            <td>Mg</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Mg }}
                                </h6>
                            </td>
                            <td>N·mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Ht × ht</th>
                            <td>Mt</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Mt }}
                                </h6>
                            </td>
                            <td>N·mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Md + Mg + Mt</th>
                            <td>Mop</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ flangeIntegralCalculator.Mop }}
                                </h6> 
                            </td>
                            <td>N·mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Atmospheric Conditions -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>12. ATMOSPHERIC CONDITIONS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">FLANGE LOAD</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">W</th>
                            <td>Hg</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Hg2 }}
                            </h6></td>
                            <td>N</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">LEVER ARM</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">(C - G)/2</th>
                            <td>hg</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.hg }}
                            </h6></td>
                            <td>mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">FLANGE MOMENT</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Hg × hg</th>
                            <td>Matm</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Matm }}
                            </h6></td>
                            <td>N·mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">TOTAL MOMENTS ON FLANGE</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Bolt correction factor</th>
                            <td>CF</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.CF }}
                            </h6></td>
                            <td> - </td>
                        </tr>
                        <tr>
                            <th scope="row">Moment at operative condition (Mop × CF / B)</th>
                            <td>Mo</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Mo }}
                            </h6></td>
                            <td>N·mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Moment at operative condition (Matm × CF / B)</th>
                            <td>Ma</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Ma }}
                            </h6></td>
                            <td>N·mm</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Shape Constants -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>13. SHAPE CONSTANTS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">DESCRIPTION</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">A/B</th>
                            <td>K</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.K }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">fig. 2-7.1</th>
                            <td>T</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.T }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">fig. 2-7.1</th>
                            <td>Z</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Z }}
                            </h6></td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th scope="row">Y</th>
                            <td>Y</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Y }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">U</th>
                            <td>U</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.U }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">g1/g0</th>
                            <td>g1g0</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.g1g0 }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">sqrt(B g0)</th>
                            <td>h0</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.h0 }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">h/h0</th>
                            <td>hh0</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.hh0 }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">fig. 2-7.2</th>
                            <td>F</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.F }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">fig. 2-7.3</th>
                            <td>V</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.V }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">fig. 2-7.6</th>
                            <td>f</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.fShape }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">F/h0</th>
                            <td>e</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.e }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">(U/V) h0 g02</th>
                            <td>d</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.d }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>t</b></span>
                                <InterrogacaoHover text="Espessura efetiva do flange utilizada nos cálculos de tensões. Parâmetro crítico nas equações de tensão radial, tangencial e longitudinal segundo ASME Appendix 2." />
                            </th>
                            <td><b>t</b></td>
                            <td><input type="number" step="any" class="form-control" v-model="flangeIntegralCalculator.t" required/></td>
                            <td><b>-</b></td>
                        </tr>
                        <tr>
                            <th scope="row">beta=(1.33te+1)</th>
                            <td>beta</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.beta }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <th scope="row">(te +1)/T + (3/d)</th>
                            <td>L</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.L }}
                            </h6></td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Stress Calculations -->
            <div class="form-group row">
                <div class="col-12">
                    <h5 class="text mt-5 text-primary"><b>14. STRESS CALCULATIONS</b></h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">CONDITION</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">OPERATING</th>
                            <th scope="col"></th>
                            <th scope="col">AMBIENT</th>
                            <th scope="col">LIMIT AMBIENT</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Longitudinal hub stress SH = (fMo) / (L t²B)</th>
                            <td>SH</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SH_operating }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.SH_operating > flangeIntegralCalculator.SH_ambient" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SH_ambient }}
                            </h6></td>
                            <td>Min (1.5Sto; 2.5Sn)</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Radial flange stress SR = (beta Mo) / (L t²B)</th>
                            <td>SR</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SR_operating }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.SR_operating > flangeIntegralCalculator.SR_ambient" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SR_ambient }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Tangent flange stress ST = (y Mo) / (t² B) - Z SR</th>
                            <td>ST</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.ST_operating }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.ST_operating > flangeIntegralCalculator.ST_ambient" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.ST_ambient }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Max. of 0.5 × (SH + SR) or 0.5 × (SH + ST)</th>
                            <td>Smax</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Smax_operating }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.Smax_operating > flangeIntegralCalculator.Smax_ambient" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Smax_ambient }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                    </tbody>
                </table>
            
            </div>

            <div class="table-responsive">

                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">CONDITION</th>
                            <th scope="col">SYMBOL</th>
                            <th scope="col">OPERATING</th>
                            <th scope="col">LIMIT OPERATING</th>
                            <th scope="col">AMBIENT</th>
                            <th scope="col">LIMIT AMBIENT</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Longitudinal hub stress SH = (fMo) / (L t²B)(AMBIENT)</th>
                            <td>SH</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SH_ambient_1 }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.SH_ambient_1 > flangeIntegralCalculator.SH_ambient_2" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SH_ambient_2 }}
                            </h6></td>
                            <td>Min (1.5Sto; 2.5Sn)</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Radial flange stress SR = (beta Mo) / (L t²B)(AMBIENT)</th>
                            <td>SR</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SR_ambient_1 }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.SR_ambient_1 > flangeIntegralCalculator.SR_ambient_2" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.SR_ambient_2 }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Tangent flange stress ST = (y Mo) / (t² B) - Z SR(AMBIENT)</th>
                            <td>ST</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.ST_ambient_1 }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.ST_ambient_1 > flangeIntegralCalculator.ST_ambient_2" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.ST_ambient_2 }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Max. of 0.5 × (SH + SR) or 0.5 × (SH + ST)(AMBIENT)</th>
                            <td>Smax</td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Smax_ambient_1 }}
                            </h6></td>
                            <td v-if = "flangeIntegralCalculator.Smax_ambient_1 > flangeIntegralCalculator.Smax_ambient_2" class="texto-vermelho"> > </td>
                            <td v-else class="texto-azul"> &lt; </td>
                            <td><h6 class="text my-auto">
                                {{ flangeIntegralCalculator.Smax_ambient_2 }}
                            </h6></td>
                            <td>Sto</td>
                            <td>MPa</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- Drawing -->
            <div class="form-group calculator-drawing mb-3 row">
                <div class="calculator-drawing-title">Drawing</div>
                <div class="col d-flex justify-content-center">
                    <div class="calculator-drawing-frame">
                        <img src="../img/calculator-flange-integral/drawing-flange-integral.png" alt="Image of Drawing" class="calculator-drawing-image">
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import DatabaseThickPlateASTM_A20 from "@/models/database/DatabaseThickPlateASTM_A20.js";
import arrayMateriaisASMEII from "../../../../backend/src/database/asmeii/arrayMateriaisASMEII.js";
import arrayBolts from "@/models/database/Bolts.js";
import arrayGasketMaterial from "@/models/database/GasketMaterial.js";
import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";
import DesenhoApoio from "../../componentesTelas/DesenhoApoio.vue";

export default {
    name: "FlangeIntegralCalculatorComponent",
    props: {
        flangeIntegralCalculatorProps: {
            type: Object,
            required: true,
        },
        designData: {
            type: Object,
            required: true,
        },
    },
    components: {
        InterrogacaoHover,
        DesenhoApoio
    },
    data() {
        return {
            flangeIntegralCalculator: this.flangeIntegralCalculatorProps,
            nominalThicknessOptions: [],

            // BUSCA MATERIAL
            materialSpecificationOptions: [],
            materialSearch: "",
            mostrarListaMaterial: false,
            debounceTimeout: null,

            // GASKET MATERIAL
            gasketOptions: [],
            gasketSelecionado: "",

            // BOLTS
            boltOptions: [],
            boltSelecionado: "",

            // EXIBIR DESENHO DE APOIO
            showDrawing: false,
        };
    },
    mounted() {

    },
    watch: {
        // Seta o valor do material no campo de busca
        'flangeIntegralCalculator.materialSpecification': {
            immediate: true,
            deep: true,
            handler(material) {
            if (
                material &&
                typeof material === 'object' &&
                material.materialSpecification
            ) {
                this.materialSearch = material.materialSpecification;
            }
            }
        },

        // === SINCRONIZA BOLT ===
        'flangeIntegralCalculator.bolt': {
            immediate: true,
            handler(nomeBolt) {
                if (!nomeBolt || !this.boltOptions.length) return;

                const encontrado = this.boltOptions.find(
                    bolt => bolt.name === nomeBolt
                );

                if (encontrado) {
                    this.boltSelecionado = encontrado;
                }
            }
        },

        // === SINCRONIZA GASKET ===
        'flangeIntegralCalculator.gasket': {
            immediate: true,
            handler(nomeGasket) {
                if (!nomeGasket || !this.gasketOptions.length) return;

                const encontrado = this.gasketOptions.find(
                    gasket => gasket.name === nomeGasket
                );

                if (encontrado) {
                    this.gasketSelecionado = encontrado;
                }
            }
        },

        // GASKET SELECIONADO
        gasketSelecionado(gasket) {
            if (!gasket) return;

            // Nome do material
            this.flangeIntegralCalculator.gasket = gasket.name;

            // Parâmetros ASME
            this.flangeIntegralCalculator.y = gasket.y_N_mm2 ?? 0;
            this.flangeIntegralCalculator.m = gasket.m ?? 0;

        },

        // BOLT SELECIONADO
        boltSelecionado(bolt) {
            if (!bolt) return;

            // Nome do material
            this.flangeIntegralCalculator.bolt = bolt.name;

            // Parâmetros ASME
            this.flangeIntegralCalculator.sba = bolt.stresses["40"] ?? 0;

        }
    },
    computed: {
        // Lista de materiais filtrados
        materiaisFiltrados() {
            const termo = this.materialSearch.toLowerCase().trim();
            
            let resultados;
            
            if (!termo) {
                resultados = this.materialSpecificationOptions;
            } else {
                resultados = this.materialSpecificationOptions.filter(mat => {
                    const materialName = mat.materialSpecification?.toLowerCase() || '';
                    return materialName.includes(termo);
                });
            }
            
            // ORDENAÇÃO GARANTIDA - por materialSpecification em ordem crescente
            const resultadosOrdenados = [...resultados].sort((a, b) => {
                const nameA = (a.materialSpecification || '').toString();
                const nameB = (b.materialSpecification || '').toString();
                
                // Extrai números dos nomes para ordenação numérica apropriada
                const numMatchA = nameA.match(/\d+/g);
                const numMatchB = nameB.match(/\d+/g);
                
                // Se ambos têm números, ordena numericamente
                if (numMatchA && numMatchB) {
                    // Compara o primeiro número encontrado
                    const numA = parseInt(numMatchA[0]);
                    const numB = parseInt(numMatchB[0]);
                    
                    if (numA !== numB) {
                        return numA - numB;
                    }
                }
                
                // Fallback para ordenação alfabética com localeCompare
                return nameA.localeCompare(nameB, undefined, { 
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            
            return resultadosOrdenados;
        }
    },
    created() {
        const database1 = new DatabaseThickPlateASTM_A20();
        this.nominalThicknessOptions = database1.nominalThickness;

         // GASKETS
        const gasketArray = new arrayGasketMaterial();
        this.gasketOptions = gasketArray.gasketMaterials;

        // OPTIONS
        const boltsArray = new arrayBolts();
        this.boltOptions = boltsArray.arrayBolts;

        // Carrega e ORDENA os materiais em ordem crescente
        this.carregarMateriaisOrdenados();
    },
    methods: {

        // CONTROLES DO DESENHO DE APOIO
        mostrarDesenho() {
            if(this.showDrawing === false){
                this.showDrawing = true;
            }
            else{
                this.showDrawing = false;
            }            
        },

        // CONTROLE DA IMAGEM FLUTUANTE
        startDrag(e) {
            this.dragging = true
            this.offsetX = e.clientX - this.posX
            this.offsetY = e.clientY - this.posY

            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
        },

        onDrag(e) {
            if (!this.dragging) return
            this.posX = e.clientX - this.offsetX
            this.posY = e.clientY - this.offsetY
        },

        stopDrag() {
            this.dragging = false
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
        },

        abrirListaMaterial() {
            this.mostrarListaMaterial = true;
        },

        fecharListaMaterial() {
            setTimeout(() => {
            this.mostrarListaMaterial = false;
            }, 150);
        },

        // Método para carregar e ordenar materiais
        carregarMateriaisOrdenados() {
            if (Array.isArray(arrayMateriaisASMEII)) {
                // Ordena os materiais pelo materialSpecification em ordem crescente
                this.materialSpecificationOptions = arrayMateriaisASMEII
                    .slice() // Cria uma cópia
                    .sort((a, b) => {
                        const materialA = a.materialSpecification || '';
                        const materialB = b.materialSpecification || '';
                        
                        // Extrai números para ordenação numérica
                        const numMatchA = materialA.match(/\d+/g);
                        const numMatchB = materialB.match(/\d+/g);
                        
                        if (numMatchA && numMatchB) {
                            const numA = parseInt(numMatchA[0]);
                            const numB = parseInt(numMatchB[0]);
                            
                            if (numA !== numB) {
                                return numA - numB;
                            }
                        }
                        
                        // Ordenação alfabética para strings sem números ou números iguais
                        return materialA.localeCompare(materialB, undefined, { 
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });

                } 
                else {
                console.error('arrayMateriaisASMEII não é um array válido');
                this.materialSpecificationOptions = [];
            }
        },

        // Método para lidar com input enquanto digita
        handleInput() {
            // Limpa timeout anterior
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            
            // Abre a lista imediatamente quando começa a digitar
            if (this.materialSearch.trim() !== '' && !this.mostrarListaMaterial) {
                this.mostrarListaMaterial = true;
            }
            
            // Se apagou tudo, fecha a lista
            if (this.materialSearch.trim() === '') {
                this.mostrarListaMaterial = false;
                return;
            }
            
            // Configura novo timeout para garantir que a lista fique aberta
            this.debounceTimeout = setTimeout(() => {
                if (this.materialSearch.trim() !== '') {
                    this.mostrarListaMaterial = true;
                }
            }, 100);
        },

        selecionarMaterial(material) {
            this.flangeIntegralCalculator.materialSpecification = material;
            this.flangeIntegralCalculator.materialSearch = material.materialSpecification;
            this.flangeIntegralCalculator.flangeMaterial = material.materialSpecification;
            this.materialSearch = material.materialSpecification;
            this.mostrarListaMaterial = false;

            // this.calculos();
        },

        buscarCampoATAtmosphericTemp() {

             if (!this.boltSelecionado || !this.boltSelecionado.stresses) {
                console.warn("Bolt ainda não selecionado");
                return 0;
            }

            const tabela = this.boltSelecionado.stresses;
            // 🔹 normaliza a chave buscada
            let chaveNormalizada = this.flangeIntegralCalculator.designTemperature;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const temperaturaExata = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
                return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
                (chaveBuscada - tempAnterior) /
                (tempPosterior - tempAnterior);

            const interpolado =
                valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);
        },

        buscarCamposSFOSFADatabaseASMEII(materialSpecification, chaveGrausCelsiusBuscada) {

            if (!materialSpecification || !materialSpecification.rangeDesignTemperatureCelsius) {
                console.warn("Material ou rangeDesignTemperatureCelsius não encontrado");
                return null;
            }

            const tabela = materialSpecification.rangeDesignTemperatureCelsius;

            // 🔹 normaliza a chave buscada
            let chaveNormalizada = chaveGrausCelsiusBuscada;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const temperaturaExata = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
                return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
                (chaveBuscada - tempAnterior) /
                (tempPosterior - tempAnterior);

            const interpolado =
                valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);

        },


        async calculos() {

            if (this.$refs.formCalculo && !this.$refs.formCalculo.reportValidity()) {
                return;
            }

            // Definir atributos como float
            this.flangeIntegralCalculator.idFlange = this.converterParaFloat(this.flangeIntegralCalculator.idFlange)
            this.flangeIntegralCalculator.shellAllowStress = this.converterParaFloat(this.flangeIntegralCalculator.shellAllowStress);
            this.flangeIntegralCalculator.sto = this.converterParaFloat(this.flangeIntegralCalculator.sto);
            this.flangeIntegralCalculator.t = this.converterParaFloat(this.flangeIntegralCalculator.t);
            this.flangeIntegralCalculator.thicknessHubSmallEnd = this.converterParaFloat(this.flangeIntegralCalculator.thicknessHubSmallEnd);


            //-----------------------------------------FLANGE---------------------------------------------
            

            //g1
            this.flangeIntegralCalculator.thicknessHubBack = this.converterParaFloat(this.flangeIntegralCalculator.thicknessHubBack)

            // R      
            this.flangeIntegralCalculator.R = this.converterParaFloat((((this.flangeIntegralCalculator.centerBoltDiameter - this.flangeIntegralCalculator.idFlange) / 2) - this.flangeIntegralCalculator.thicknessHubBack).toFixed(3));
            

            // B1
            if (this.flangeIntegralCalculator.f < 1) {
                this.flangeIntegralCalculator.b1 =
                    this.converterParaFloat(
                        this.flangeIntegralCalculator.idFlange +
                        this.flangeIntegralCalculator.thicknessHubBack);
            } else {
                this.flangeIntegralCalculator.b1 = this.converterParaFloat(
                    this.flangeIntegralCalculator.idFlange +
                    this.flangeIntegralCalculator.thicknessHubSmallEnd);
            }

            
            //Stress Area
            //=0,924*(0,7854*((E36-(0,9743/G36))^2))*(25,4*25,4)
            this.flangeIntegralCalculator.rootDiameter = this.converterParaFloat((0.924 * (0.7854 * Math.pow((this.flangeIntegralCalculator.boltDiameter - (0.9743 / this.flangeIntegralCalculator.pitchDiameter)), 2)) * (25.4 * 25.4)).toFixed(0));

            //-----------------------------------------GASKET---------------------------------------------

            //N
            this.flangeIntegralCalculator.N = this.converterParaFloat(((this.flangeIntegralCalculator.odGasket - this.flangeIntegralCalculator.idGasket) / 2).toFixed(3));

            //b0
            this.flangeIntegralCalculator.b0 = this.converterParaFloat((this.flangeIntegralCalculator.N / 2).toFixed(3));

            //b
            if (this.flangeIntegralCalculator.b0 <= 6.35) {
                this.flangeIntegralCalculator.b =
                    this.converterParaFloat(this.flangeIntegralCalculator.b0.toFixed(3));
            } else {
                this.flangeIntegralCalculator.b =
                    this.converterParaFloat((2.52 * Math.pow(this.flangeIntegralCalculator.b0, 0.5)).toFixed(3));
            }

            // Load reaction gasket diam.
            if (this.flangeIntegralCalculator.b0 <= 6) {
                this.flangeIntegralCalculator.loadReactionGasketDiameter = this.converterParaFloat(
                    ((this.flangeIntegralCalculator.odGasket + this.flangeIntegralCalculator.idGasket) / 2).toFixed(1)
                );
            } else {
                this.flangeIntegralCalculator.loadReactionGasketDiameter = this.converterParaFloat(
                    (this.flangeIntegralCalculator.odGasket - (2 * this.flangeIntegralCalculator.b)).toFixed(1)
                );
            }

            //Wm2
            this.flangeIntegralCalculator.Wm2 = this.converterParaFloat((3.1415 * (this.flangeIntegralCalculator.b *
                this.flangeIntegralCalculator.loadReactionGasketDiameter * this.flangeIntegralCalculator.y)).toFixed(3));

            //Hp
            this.flangeIntegralCalculator.Hp = this.converterParaFloat((6.28 * this.flangeIntegralCalculator.b * this.flangeIntegralCalculator.loadReactionGasketDiameter * this.flangeIntegralCalculator.m * this.flangeIntegralCalculator.designPressureInternal).toFixed(3));

            //H
            this.flangeIntegralCalculator.H = this.converterParaFloat((0.785 * Math.pow(this.flangeIntegralCalculator.loadReactionGasketDiameter, 2) * this.flangeIntegralCalculator.designPressureInternal).toFixed(3));

            //Wm1
            this.flangeIntegralCalculator.Wm1 = this.converterParaFloat((this.flangeIntegralCalculator.Hp + this.flangeIntegralCalculator.H).toFixed(3));

            // AT atmospheric temp
            this.flangeIntegralCalculator.sbo = this.buscarCampoATAtmosphericTemp(this.flangeIntegralCalculator.boltMaterial, this.flangeIntegralCalculator.designTemperature);

            // AT design temp - SBA
            const chaveGrausCelsiusBuscada = this.designData.designTemperature;

            try {
                const resultado = await this.buscarCamposSFOSFADatabaseASMEII(
                    this.flangeIntegralCalculator.materialSpecification,
                    chaveGrausCelsiusBuscada
                );

                this.flangeIntegralCalculator.sfo = resultado;

            } catch (error) {
                console.error("Erro ao buscar AT design temp - SBA:", error);
            }

            // AT atmospheric temp - SFA
            try {
                const resultado = await this.buscarCamposSFOSFADatabaseASMEII(
                    this.flangeIntegralCalculator.materialSpecification,
                    "37,78"
                );
                this.flangeIntegralCalculator.sfa = resultado;
            } catch (error) {
                console.error("Erro ao buscar AT atmospheric temp - SFA:", error);
            }

            //Am
            this.flangeIntegralCalculator.Am = this.converterParaFloat(Math.max((this.flangeIntegralCalculator.Wm2 / this.flangeIntegralCalculator.sba), (this.flangeIntegralCalculator.Wm1 / this.flangeIntegralCalculator.sbo)).toFixed(3));

            //Ab
            this.flangeIntegralCalculator.Ab = (this.flangeIntegralCalculator.boltsQuantity * this.flangeIntegralCalculator.rootDiameter);

            //W1
            this.flangeIntegralCalculator.W1 = this.converterParaFloat(((this.flangeIntegralCalculator.Am + this.flangeIntegralCalculator.Ab) * this.flangeIntegralCalculator.sba / 2).toFixed(3));

            //W2
            this.flangeIntegralCalculator.W2 = this.converterParaFloat((this.flangeIntegralCalculator.Ab * this.flangeIntegralCalculator.sba).toFixed(3));

            // Largura Minima Junta
            this.flangeIntegralCalculator.larguraMinimaJunta = this.converterParaFloat((this.flangeIntegralCalculator.W2 / (2 * 3.141516 * this.flangeIntegralCalculator.loadReactionGasketDiameter * this.flangeIntegralCalculator.y)).toFixed(2));
            
            //W
            if (this.flangeIntegralCalculator.overboltingSelect == 0) {
                this.flangeIntegralCalculator.W = this.flangeIntegralCalculator.W1.toFixed(3);
            } else {
                this.flangeIntegralCalculator.W = this.flangeIntegralCalculator.W2.toFixed(3);
            }

            //-------------------------------------------Operating Conditions-----------------------------------

            //Hd
            this.flangeIntegralCalculator.Hd = this.converterParaFloat((0.785 * Math.pow(this.flangeIntegralCalculator.idFlange, 2) * this.flangeIntegralCalculator.designPressureInternal).toFixed(3));

            //Hg
            this.flangeIntegralCalculator.Hg = this.converterParaFloat((this.flangeIntegralCalculator.Wm1 - this.flangeIntegralCalculator.H).toFixed(3));

            //Ht
            this.flangeIntegralCalculator.Ht = this.converterParaFloat((this.flangeIntegralCalculator.H - this.flangeIntegralCalculator.Hd).toFixed(3));

            //hd
            this.flangeIntegralCalculator.hd = this.converterParaFloat((this.flangeIntegralCalculator.R + (0.5 * this.flangeIntegralCalculator.thicknessHubBack)).toFixed(3));

            //hg
            this.flangeIntegralCalculator.hg = this.converterParaFloat(((this.flangeIntegralCalculator.centerBoltDiameter - this.flangeIntegralCalculator.loadReactionGasketDiameter) / 2).toFixed(3));

            //ht
            this.flangeIntegralCalculator.ht = this.converterParaFloat(((this.flangeIntegralCalculator.R + this.flangeIntegralCalculator.thicknessHubBack + this.flangeIntegralCalculator.hg) / 2).toFixed(3));

            //Md
            this.flangeIntegralCalculator.Md = this.converterParaFloat((this.flangeIntegralCalculator.Hd * this.flangeIntegralCalculator.hd).toFixed(3));

            //Mg
            this.flangeIntegralCalculator.Mg = this.converterParaFloat((this.flangeIntegralCalculator.Hg * this.flangeIntegralCalculator.hg).toFixed(3));

            //Mt
            this.flangeIntegralCalculator.Mt = this.converterParaFloat((this.flangeIntegralCalculator.Ht * this.flangeIntegralCalculator.ht).toFixed(3));

            //Mop
            this.flangeIntegralCalculator.Mop = this.converterParaFloat((this.flangeIntegralCalculator.Md + this.flangeIntegralCalculator.Mg + this.flangeIntegralCalculator.Mt).toFixed(3));

            //-------------------------------------------Atmospheric Conditions-----------------------------------

            //HG
            this.flangeIntegralCalculator.Hg2 = this.converterParaFloat(this.flangeIntegralCalculator.W);

            //Matm
            this.flangeIntegralCalculator.Matm = this.converterParaFloat((this.flangeIntegralCalculator.hg * this.flangeIntegralCalculator.Hg2).toFixed(3));

            //CF
            this.flangeIntegralCalculator.CF = 1;

            //Mo
            this.flangeIntegralCalculator.Mo = this.converterParaFloat((this.flangeIntegralCalculator.Mop * (1 / this.flangeIntegralCalculator.idFlange)).toFixed(3));

            //Ma
            this.flangeIntegralCalculator.Ma = this.converterParaFloat((this.flangeIntegralCalculator.Matm * (1 / this.flangeIntegralCalculator.idFlange)).toFixed(3));

            //-------------------------------------------Shape Constants-----------------------------------

            //K
            this.flangeIntegralCalculator.K = this.converterParaFloat((this.flangeIntegralCalculator.odFlange / this.flangeIntegralCalculator.idFlange).toFixed(4));

            //T
            this.flangeIntegralCalculator.T = this.converterParaFloat(((Math.pow(this.flangeIntegralCalculator.K, 2) *
                (Math.log10(this.flangeIntegralCalculator.K) * 8.55246 + 1) - 1) /
                ((1.0472 + (1.9448 * Math.pow(this.flangeIntegralCalculator.K, 2))) * (this.flangeIntegralCalculator.K - 1))).toFixed(4));

            //Z
            this.flangeIntegralCalculator.Z = this.converterParaFloat(((Math.pow(this.flangeIntegralCalculator.K, 2) + 1) / (Math.pow(this.flangeIntegralCalculator.K, 2) - 1)).toFixed(4));

            //Y
            //=((1/(C63-1))*(0,66845+(5,7169*(C63^2*LOG10(C63))/(C63^2-1))))
            this.flangeIntegralCalculator.Y = this.converterParaFloat(((1 / (this.flangeIntegralCalculator.K - 1)) *
                (0.66845 + (5.7169 * (Math.pow(this.flangeIntegralCalculator.K, 2) * Math.log10(this.flangeIntegralCalculator.K)) /
                    (Math.pow(this.flangeIntegralCalculator.K, 2) - 1)))).toFixed(4));

            //U
            //=(((C63^2)*(1+(8,55246*(LOG10(C63)))))-1)/(1,36136*(C63^2-1)*(C63-1))
            this.flangeIntegralCalculator.U = this.converterParaFloat((((Math.pow(this.flangeIntegralCalculator.K,2)*(1+(8.55246*(Math.log10(this.flangeIntegralCalculator.K)))))-1)/(1.36136*(Math.pow(this.flangeIntegralCalculator.K,2)-1)*(this.flangeIntegralCalculator.K -1))).toFixed(4));

            //g1g0
            this.flangeIntegralCalculator.g1g0 = this.converterParaFloat((this.flangeIntegralCalculator.thicknessHubBack / this.flangeIntegralCalculator.thicknessHubSmallEnd).toFixed(4));

            //h0
            this.flangeIntegralCalculator.h0 = this.converterParaFloat((
                Math.sqrt(
                    (this.flangeIntegralCalculator.idFlange *
                        this.flangeIntegralCalculator.thicknessHubSmallEnd)
                    / (25.4 ** 2)
                ) * 25.4).toFixed(4));

            //hh0
            this.flangeIntegralCalculator.hh0 = this.converterParaFloat((this.flangeIntegralCalculator.hubLength / this.flangeIntegralCalculator.h0).toFixed(4));

            // f
            this.flangeIntegralCalculator.f = this.converterParaFloat(Math.min(
                (this.flangeIntegralCalculator.thicknessHubBack / this.flangeIntegralCalculator.thicknessHubSmallEnd),
                this.flangeIntegralCalculator.hh0
            ).toFixed(2));

            //---------------------------------------------------------------------------------
                        //Eq. dos fatores de forma
            //(A)
            this.flangeIntegralCalculator.A = this.converterParaFloat((this.flangeIntegralCalculator.g1g0) - 1);
            //(C)
            //=43,68*(G63^4)
            this.flangeIntegralCalculator.C = this.converterParaFloat(43.68 * Math.pow(this.flangeIntegralCalculator.hh0, 4));
            //C1
            //=1/3 + B86/12
            this.flangeIntegralCalculator.C1 = this.converterParaFloat((1/3 + this.flangeIntegralCalculator.A/12));
            //C2
            //=5/42 + (17*B86/336)
            this.flangeIntegralCalculator.C2 = this.converterParaFloat((5/42 + (17*this.flangeIntegralCalculator.A/336)))
            //C3
            //=1/210 + B86/360
            this.flangeIntegralCalculator.C3 = this.converterParaFloat((1/210 + this.flangeIntegralCalculator.A/360));
            //C4
            //=11/360 + (59*B86/5040) + (1+3*B86)/B87
            this.flangeIntegralCalculator.C4 = this.converterParaFloat((11/360 + (59*this.flangeIntegralCalculator.A/5040) + (1+3*this.flangeIntegralCalculator.A)/this.flangeIntegralCalculator.C))
            //C5
            //= 1/90 + (5*B86/1008) - ((1+B86)^3)/B87
            this.flangeIntegralCalculator.C5 = this.converterParaFloat((1/90 + (5*this.flangeIntegralCalculator.A/1008) - (Math.pow((1+this.flangeIntegralCalculator.A),3)/this.flangeIntegralCalculator.C)))
            //C6
            //=1/120 + (17*B86/5040) + 1/B87
            this.flangeIntegralCalculator.C6 = this.converterParaFloat((1/120 + (17*this.flangeIntegralCalculator.A/5040) + 1/this.flangeIntegralCalculator.C));
            //C7
            //=(215/2772 + (51*B86/1232) +((60/7 + (225*B86/14) + (75*(B86^2))/7 + (5*(B86^3)/2))/B87))
            this.flangeIntegralCalculator.C7 = this.converterParaFloat(((215/2772 + (51*this.flangeIntegralCalculator.A/1232) +((60/7 + (225 * this.flangeIntegralCalculator.A/14) + (75*Math.pow(this.flangeIntegralCalculator.A,2))/7 + (5*Math.pow(this.flangeIntegralCalculator.A,3)/2))/this.flangeIntegralCalculator.C))));
            //C8
            //=(31/6930 + (128*B86/45045) + (((6/7) + (15*B86/7) +((12*(B86^2))/7) + ((5*(B86^3))/11))/B87))
            this.flangeIntegralCalculator.C8 = this.converterParaFloat(((31/6930 + (128*this.flangeIntegralCalculator.A/45045) + (((6/7) + (15*this.flangeIntegralCalculator.A/7) +((12*Math.pow(this.flangeIntegralCalculator.A,2))/7) + ((5*Math.pow(this.flangeIntegralCalculator.A,3))/11))/this.flangeIntegralCalculator.C))));
            //C9
            //=(533/30240 + (653*B86/73920) + (((1/2) + (33*B86/14) + ((39*(B86^2))/28) + ((25*(B86^3))/84))/B87))
            this.flangeIntegralCalculator.C9 = this.converterParaFloat(((533/30240 + (653*this.flangeIntegralCalculator.A/73920) + (((1/2) + (33*this.flangeIntegralCalculator.A/14) + ((39*Math.pow(this.flangeIntegralCalculator.A,2))/28) + ((25*Math.pow(this.flangeIntegralCalculator.A,3))/84))/this.flangeIntegralCalculator.C))));
            //C10
            //=(29/3780 + (3*B86/704) - (((1/2) + (33*B86/14) + ((81*(B86^2))/28) + ((13*(B86^3))/12))/B87))
            this.flangeIntegralCalculator.C10 = this.converterParaFloat(((29/3780 + (3*this.flangeIntegralCalculator.A/704) - (((1/2) + (33*this.flangeIntegralCalculator.A/14) + ((81*Math.pow(this.flangeIntegralCalculator.A,2))/28) + ((13*Math.pow(this.flangeIntegralCalculator.A,3))/12))/this.flangeIntegralCalculator.C))));
            //C11
            //=(31/6048 + (1763*B86/665280) + (((1/2) + (6*B86/7) + ((15*(B86^2))/28) + ((5*(B86^3))/42))/B87))
            this.flangeIntegralCalculator.C11 = this.converterParaFloat(((31/6048 + (1763*this.flangeIntegralCalculator.A/665280) + (((1/2) + (6*this.flangeIntegralCalculator.A/7) + ((15*Math.pow(this.flangeIntegralCalculator.A,2))/28) + ((5*Math.pow(this.flangeIntegralCalculator.A,3))/42))/this.flangeIntegralCalculator.C))));
            //C12
            //=(1/2925 + (71*B86/300300) + (((8/35) + (18*(B86)/35) +((156*(B86^2))/385) + ((6*(B86^3))/55))/B87))
            this.flangeIntegralCalculator.C12 = this.converterParaFloat(((1/2925 + (71*this.flangeIntegralCalculator.A/300300) + (((8/35) + (18*(this.flangeIntegralCalculator.A)/35) +((156*Math.pow(this.flangeIntegralCalculator.A,2))/385) + ((6*Math.pow(this.flangeIntegralCalculator.A,3))/55))/this.flangeIntegralCalculator.C))));
            //C13
            //=(761/831600 + (937*B86/1663200) + (((1/35) + (6*B86/35) + (11*(B86^2)/70) + (3*(B86^3)/70))/B87))
            this.flangeIntegralCalculator.C13 = this.converterParaFloat(((761/831600 + (937*this.flangeIntegralCalculator.A/1663200) + (((1/35) + (6*this.flangeIntegralCalculator.A/35) + (11*Math.pow(this.flangeIntegralCalculator.A,2)/70) + (3*Math.pow(this.flangeIntegralCalculator.A,3)/70))/this.flangeIntegralCalculator.C))));
            //C14
            //=(197/415800 + (103*B86/332640) - (((1/35) + (6*B86/35) + (17*(B86^2)/70) + ((B86^3)/10))/B87))
            this.flangeIntegralCalculator.C14 = this.converterParaFloat(((197/415800 + (103*this.flangeIntegralCalculator.A/332640) - (((1/35) + (6*this.flangeIntegralCalculator.A/35) + (17*Math.pow(this.flangeIntegralCalculator.A,2)/70) + ((Math.pow(this.flangeIntegralCalculator.A,3))/10))/this.flangeIntegralCalculator.C))));
            //C15
            //=(233/831600+(97*B86/554400)+(((1/35)+(3*B86/35)+((B86^2)/14)+((2*(B86^3))/105))/B87))
            this.flangeIntegralCalculator.C15 = this.converterParaFloat(((233/831600+(97*this.flangeIntegralCalculator.A/554400)+(((1/35)+(3*this.flangeIntegralCalculator.A/35)+((Math.pow(this.flangeIntegralCalculator.A,2))/14)+((2*Math.pow(this.flangeIntegralCalculator.A,3))/105))/this.flangeIntegralCalculator.C)))); 
            //C16
            //=(B88*B94*B99+B89*B95*B90+B90*B95*B89)-(((B90^2)*B94)+((B95^2)*B88)+((B89^2)*B99))
            this.flangeIntegralCalculator.C16 = this.converterParaFloat(((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C12) +
                (this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C2)) -
                (((Math.pow(this.flangeIntegralCalculator.C3, 2)) * this.flangeIntegralCalculator.C7) +
                    ((Math.pow(this.flangeIntegralCalculator.C8, 2)) * this.flangeIntegralCalculator.C1) +
                    ((Math.pow(this.flangeIntegralCalculator.C2, 2)) * this.flangeIntegralCalculator.C12)));
            //C17
            //=((B91*B94*B99+B89*B95*B100+B90*B95*B96)-(B100*B94*B90+(B95^2)*B91+B99*B89*B96))/B103
            this.flangeIntegralCalculator.C17 = this.converterParaFloat((((this.flangeIntegralCalculator.C4 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C12) +
                (this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C13) +
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C9)) -
                (this.flangeIntegralCalculator.C13 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C3 +
                    (Math.pow(this.flangeIntegralCalculator.C8, 2)) * this.flangeIntegralCalculator.C4 +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C9)) /
                this.flangeIntegralCalculator.C16);

            //C18
            //=((B92*B94*B99+B89*B95*B101+B90*B95*B97)-(B101*B94*B90+((B95^2)*B92)+B99*B89*B97))/B103
            this.flangeIntegralCalculator.C18 = this.converterParaFloat(((
                this.flangeIntegralCalculator.C5 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C12 +
                this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C14 +
                this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C10) -
                (this.flangeIntegralCalculator.C14 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C3 +
                    (Math.pow(this.flangeIntegralCalculator.C8, 2) * this.flangeIntegralCalculator.C5) +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C10)) /
                this.flangeIntegralCalculator.C16);
            //C19
            //=((B93*B94*B99+B89*B95*B102+B90*B95*B98)-(B102*B94*B90+(B95^2)*B93+B99*B89*B98))/B103
            this.flangeIntegralCalculator.C19 = this.converterParaFloat(((
                this.flangeIntegralCalculator.C6 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C12 +
                this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C15 +
                this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C11) -
                (this.flangeIntegralCalculator.C15 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C3 +
                    (Math.pow(this.flangeIntegralCalculator.C8, 2)) * this.flangeIntegralCalculator.C6 +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C11)) /
                this.flangeIntegralCalculator.C16);
            //C20
            //=((B88*B96*B99+B91*B95*B90+B90*B100*B89)-((B90^2)*B96+B100*B95*B88+B99*B91*B89))/B103
            this.flangeIntegralCalculator.C20 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C9 * this.flangeIntegralCalculator.C12) +
                (this.flangeIntegralCalculator.C4 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C13 * this.flangeIntegralCalculator.C2)) -
                ((Math.pow(this.flangeIntegralCalculator.C3, 2)) * this.flangeIntegralCalculator.C9 +
                    this.flangeIntegralCalculator.C13 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C1 +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C4 * this.flangeIntegralCalculator.C2)) /
                this.flangeIntegralCalculator.C16);
            //C21
            //=((B88*B97*B99+B92*B95*B90+B90*B101*B89)-((B90^2*B97+B101*B95*B88+B99*B92*B89)))/B103
            this.flangeIntegralCalculator.C21 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C10 * this.flangeIntegralCalculator.C12) +
                (this.flangeIntegralCalculator.C5 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C14 * this.flangeIntegralCalculator.C2)) -
                ((Math.pow(this.flangeIntegralCalculator.C3, 2) * this.flangeIntegralCalculator.C10 +
                    this.flangeIntegralCalculator.C14 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C1 +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C5 * this.flangeIntegralCalculator.C2))) /
                this.flangeIntegralCalculator.C16);
            //C22
            //=((B88*B98*B99+B93*B95*B90+B90*B102*B89)-((B90^2)*B98+B102*B95*B88+B99*B93*B89))/B103
            this.flangeIntegralCalculator.C22 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C11 * this.flangeIntegralCalculator.C12) +
                (this.flangeIntegralCalculator.C6 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C15 * this.flangeIntegralCalculator.C2)) -
                ((Math.pow(this.flangeIntegralCalculator.C3, 2)) * this.flangeIntegralCalculator.C11 +
                    this.flangeIntegralCalculator.C15 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C1 +
                    this.flangeIntegralCalculator.C12 * this.flangeIntegralCalculator.C6 * this.flangeIntegralCalculator.C2)) /
                this.flangeIntegralCalculator.C16);
            //C23
            //=((B88*B94*B100+B89*B96*B90+B91*B95*B89)-(B90*B94*B91+B95*B96*B88+((B89^2)*B100)))/B103
            this.flangeIntegralCalculator.C23 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C13) +
                (this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C9 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C4 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C2)) -
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C4 +
                    this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C9 * this.flangeIntegralCalculator.C1 +
                    (Math.pow(this.flangeIntegralCalculator.C2, 2)) * this.flangeIntegralCalculator.C13)) /
                this.flangeIntegralCalculator.C16);
            //C24
            //=((B88*B94*B101+B89*B97*B90+B92*B95*B89)-(B90*B94*B92+B95*B97*B88+(B89^2)*B101))/B103
            this.flangeIntegralCalculator.C24 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C14) +
                (this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C10 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C5 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C2)) -
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C5 +
                    this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C10 * this.flangeIntegralCalculator.C1 +
                    (Math.pow(this.flangeIntegralCalculator.C2, 2)) * this.flangeIntegralCalculator.C14)) /
                this.flangeIntegralCalculator.C16);
            //C25
            //=((B88*B94*B102+B89*B98*B90+B93*B95*B89)-(B90*B94*B93+B95*B98*B88+(B89^2)*B102))/B103
            this.flangeIntegralCalculator.C25 = this.converterParaFloat((((this.flangeIntegralCalculator.C1 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C15) +
                (this.flangeIntegralCalculator.C2 * this.flangeIntegralCalculator.C11 * this.flangeIntegralCalculator.C3) +
                (this.flangeIntegralCalculator.C6 * this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C2)) -
                (this.flangeIntegralCalculator.C3 * this.flangeIntegralCalculator.C7 * this.flangeIntegralCalculator.C6 +
                    this.flangeIntegralCalculator.C8 * this.flangeIntegralCalculator.C11 * this.flangeIntegralCalculator.C1 +
                    (Math.pow(this.flangeIntegralCalculator.C2, 2)) * this.flangeIntegralCalculator.C15)) /
                this.flangeIntegralCalculator.C16);
            //C26
            //=-1*((B87/4)^0,25)
            this.flangeIntegralCalculator.C26 = this.converterParaFloat(-1 * (Math.pow((this.flangeIntegralCalculator.C / 4), 0.25)));
            //C27
            //=B107-B104-(5/12)+(B104*B113)
            this.flangeIntegralCalculator.C27 = this.converterParaFloat(this.flangeIntegralCalculator.C20 - this.flangeIntegralCalculator.C17 - (5/12) + (this.flangeIntegralCalculator.C17 * this.flangeIntegralCalculator.C26));
            //C28
            //=B109-B106-(1/12)+B106*B113
            this.flangeIntegralCalculator.C28 = this.converterParaFloat(this.flangeIntegralCalculator.C22 - this.flangeIntegralCalculator.C19 - (1/12) + this.flangeIntegralCalculator.C19 * this.flangeIntegralCalculator.C26);    
            //C29
            //=-1*((B87/4)^0,5)
            this.flangeIntegralCalculator.C29 = this.converterParaFloat(-1 * (Math.pow((this.flangeIntegralCalculator.C / 4), 0.5)));
            //C30
            //=-1*((B87/4)^0,75)
            this.flangeIntegralCalculator.C30 = this.converterParaFloat(-1 * (Math.pow((this.flangeIntegralCalculator.C / 4), 0.75)));
            //C31
            //=B86*1,5-(B104*B117)
            this.flangeIntegralCalculator.C31 = this.converterParaFloat(this.flangeIntegralCalculator.A * 1.5 - (this.flangeIntegralCalculator.C17 * this.flangeIntegralCalculator.C30));
            //C32
            //=0,5-(B106*B117)
            this.flangeIntegralCalculator.C32 = this.converterParaFloat(0.5 - (this.flangeIntegralCalculator.C19 * this.flangeIntegralCalculator.C30));
            //C33
            //=(0,5*B113*B119)+(B115*B118*B116)-(0,5*B117*B115+B119*B114*B116)
            this.flangeIntegralCalculator.C33 = this.converterParaFloat((0.5 * this.flangeIntegralCalculator.C26 * this.flangeIntegralCalculator.C32) +
                (this.flangeIntegralCalculator.C28 * this.flangeIntegralCalculator.C31 * this.flangeIntegralCalculator.C29) -
                (0.5 * this.flangeIntegralCalculator.C30 * this.flangeIntegralCalculator.C28 +
                    this.flangeIntegralCalculator.C32 * this.flangeIntegralCalculator.C27 * this.flangeIntegralCalculator.C29));
            //C34
            //=(1/12)+B105-B108-(B105*B113)
            this.flangeIntegralCalculator.C34 = this.converterParaFloat((1/12) + this.flangeIntegralCalculator.C18 - this.flangeIntegralCalculator.C21 - (this.flangeIntegralCalculator.C18 * this.flangeIntegralCalculator.C26));
            //C35
            //=-B105*((B87/4)^0,75)
            this.flangeIntegralCalculator.C35 = this.converterParaFloat(-1 * this.flangeIntegralCalculator.C18 * (Math.pow((this.flangeIntegralCalculator.C / 4), 0.75)));
            //C36
            //=((B115*B122*B116)-(B119*B121*B116))/B120
            this.flangeIntegralCalculator.C36 = this.converterParaFloat(((this.flangeIntegralCalculator.C28 * this.flangeIntegralCalculator.C35 * this.flangeIntegralCalculator.C29) -
                (this.flangeIntegralCalculator.C32 * this.flangeIntegralCalculator.C34 * this.flangeIntegralCalculator.C29)) /
                this.flangeIntegralCalculator.C33);
            //C37
            //=(0,5*B113*B122+B121*B118*B116-(0,5*B117*B121+B122*B114*B116))/B120
            this.flangeIntegralCalculator.C37 = this.converterParaFloat((0.5 * this.flangeIntegralCalculator.C26 * this.flangeIntegralCalculator.C35 +
                this.flangeIntegralCalculator.C34 * this.flangeIntegralCalculator.C31 * this.flangeIntegralCalculator.C29 -
                (0.5 * this.flangeIntegralCalculator.C30 * this.flangeIntegralCalculator.C34 +
                    this.flangeIntegralCalculator.C35 * this.flangeIntegralCalculator.C27 * this.flangeIntegralCalculator.C29)) /
                this.flangeIntegralCalculator.C33);
            //E1
            //=B104*B123+B105+B106*B124
            this.flangeIntegralCalculator.E1 = this.converterParaFloat((this.flangeIntegralCalculator.C17 * this.flangeIntegralCalculator.C36) +
                this.flangeIntegralCalculator.C18 +
                (this.flangeIntegralCalculator.C19 * this.flangeIntegralCalculator.C37));
            //E2
            //=B107*B123+B108+B109*B124
            this.flangeIntegralCalculator.E2 = this.converterParaFloat((this.flangeIntegralCalculator.C20 * this.flangeIntegralCalculator.C36) +
                this.flangeIntegralCalculator.C21 +
                (this.flangeIntegralCalculator.C22 * this.flangeIntegralCalculator.C37));
            //E3
            //=B110*B123+B111+B112*B124
            this.flangeIntegralCalculator.E3 = this.converterParaFloat((this.flangeIntegralCalculator.C23 * this.flangeIntegralCalculator.C36) +
                this.flangeIntegralCalculator.C24 +
                (this.flangeIntegralCalculator.C25 * this.flangeIntegralCalculator.C37));
            //E4
            //=0,25+(B124/12)+(B123/4)-(B127/5)-(3*(B126/2))-B125
            this.flangeIntegralCalculator.E4 = this.converterParaFloat(0.25 + (this.flangeIntegralCalculator.C37 / 12) + (this.flangeIntegralCalculator.C36 / 4) -
                (this.flangeIntegralCalculator.E3 / 5) - (3 * (this.flangeIntegralCalculator.E2 / 2)) - this.flangeIntegralCalculator.E1);
            //E5
            //=B125*(0,5+(B86/6))+B126*(0,25+(11*B86/84))+(B127*(1/70+B86/105))
            this.flangeIntegralCalculator.E5 = this.converterParaFloat((this.flangeIntegralCalculator.E1 * (0.5 + (this.flangeIntegralCalculator.A / 6))) +
                (this.flangeIntegralCalculator.E2 * (0.25 + (11 * this.flangeIntegralCalculator.A / 84))) +
                (this.flangeIntegralCalculator.E3 * (1/70 + this.flangeIntegralCalculator.A / 105)));
            //E6
            //=B129-(B123*((7/120)+(B86/36)+(3*(B86/B87))))-(1/40)-(B86/72)-(B124*((1/160)+(B86/120)+(1/B87)))
            this.flangeIntegralCalculator.E6 = this.converterParaFloat(this.flangeIntegralCalculator.E5 -
                (this.flangeIntegralCalculator.C36 * ((7/120) + (this.flangeIntegralCalculator.A / 36) + (3 * (this.flangeIntegralCalculator.A / this.flangeIntegralCalculator.C)))) -
                (1/40) - (this.flangeIntegralCalculator.A / 72) -
                (this.flangeIntegralCalculator.C37 * ((1/160) + (this.flangeIntegralCalculator.A / 120) + (1 / this.flangeIntegralCalculator.C))));
            //---------------------------------------------------------------------------------

            //F
            //=(-1*(B130/(((B87/2,73)^0,25)*(((1+B86)^3)/B87))))
            this.flangeIntegralCalculator.F = this.converterParaFloat((-1 * (this.flangeIntegralCalculator.E6 /
                ((Math.pow((this.flangeIntegralCalculator.C / 2.73), 0.25)) *
                    (Math.pow((1 + this.flangeIntegralCalculator.A), 3) / this.flangeIntegralCalculator.C)))).toFixed(4));

            //V
            //=(B128/((((2,73/B87)^0,25))*((1+B86)^3)))
            this.flangeIntegralCalculator.V = this.converterParaFloat((this.flangeIntegralCalculator.E4 /
                ((Math.pow((2.73 / this.flangeIntegralCalculator.C), 0.25)) *
                    (Math.pow((1 + this.flangeIntegralCalculator.A), 3)))).toFixed(4));

            //fShape
            //=SE((B123/(1+B86))>1;(B123/(1+B86));1)
            this.flangeIntegralCalculator.fShape = this.converterParaFloat(
                (this.flangeIntegralCalculator.C36 / (1 + this.flangeIntegralCalculator.A)) > 1 ?
                    (this.flangeIntegralCalculator.C36 / (1 + this.flangeIntegralCalculator.A)) : 1
            ).toFixed(4);

            //e
            this.flangeIntegralCalculator.e = this.converterParaFloat((this.flangeIntegralCalculator.F / this.flangeIntegralCalculator.h0).toFixed(4));

            //d
            this.flangeIntegralCalculator.d = this.converterParaFloat(((this.flangeIntegralCalculator.U / this.flangeIntegralCalculator.V) *
                this.flangeIntegralCalculator.h0 * Math.pow(this.flangeIntegralCalculator.thicknessHubSmallEnd, 2)).toFixed(3));

            //beta
            this.flangeIntegralCalculator.beta = this.converterParaFloat(((1.33 * this.flangeIntegralCalculator.t * this.flangeIntegralCalculator.e) + 1).toFixed(4));

            //L
            this.flangeIntegralCalculator.L = this.converterParaFloat((((this.flangeIntegralCalculator.t * this.flangeIntegralCalculator.e + 1) / this.flangeIntegralCalculator.T) + (Math.pow(this.flangeIntegralCalculator.t, 3) / this.flangeIntegralCalculator.d)).toFixed(4));

            //-------------------------------------------Stress Calculations-----------------------------------

            //Longitudinal hub stress SH = (fMo)/(Lg12B)
            //=SE(E2=0;($G$66*$K$57)/(($K$68*($E$28^2)*$E$24));($G$66*$K$57)/(($K$68*($E$28^2)*$E$32)))
                if (this.flangeIntegralCalculator.bSelect == 0) {
                    this.flangeIntegralCalculator.SH_operating = this.converterParaFloat(((this.flangeIntegralCalculator.fShape * this.flangeIntegralCalculator.Mop) / ((this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.thicknessHubBack, 2) * this.flangeIntegralCalculator.idFlange))).toFixed(4));
                } else {
                    this.flangeIntegralCalculator.SH_operating = this.converterParaFloat((this.flangeIntegralCalculator.fShape * this.flangeIntegralCalculator.Mop) / ((this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.thicknessHubBack, 2) * this.flangeIntegralCalculator.b1)).toFixed(4));
                }
            

            //Radial flange Stress SR = (betaMo)/(LT2B)
            
            this.flangeIntegralCalculator.SR_operating = this.converterParaFloat(((this.flangeIntegralCalculator.beta * this.flangeIntegralCalculator.Mop) / (this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.t, 2) * this.flangeIntegralCalculator.idFlange)).toFixed(4));

            //Tangent flange Stress ST = (YMo)/(T2b)-ZSR
            this.flangeIntegralCalculator.ST_operating = this.converterParaFloat((((this.flangeIntegralCalculator.Y * this.flangeIntegralCalculator.Mop) / (Math.pow(this.flangeIntegralCalculator.t, 2) * this.flangeIntegralCalculator.idFlange)) - (this.flangeIntegralCalculator.Z * this.flangeIntegralCalculator.SR_operating)).toFixed(4));

            //Max. Of 0,5 x(SH+SR) or 0,5 x(SH+ST))
            this.flangeIntegralCalculator.Smax_operating = this.converterParaFloat((Math.max(
                0.5 * (this.flangeIntegralCalculator.SH_operating + this.flangeIntegralCalculator.SR_operating),
                0.5 * (this.flangeIntegralCalculator.SH_operating + this.flangeIntegralCalculator.ST_operating)
            )).toFixed(4));

            //SH ambient
            this.flangeIntegralCalculator.SH_ambient = this.converterParaFloat((Math.min(
                1.5 * this.flangeIntegralCalculator.sfo,
                2.5 * this.flangeIntegralCalculator.shellAllowStress
            )).toFixed(4));

            //SR Ambient
            this.flangeIntegralCalculator.SR_ambient = this.converterParaFloat(this.flangeIntegralCalculator.sfo);

            //ST Ambient
            this.flangeIntegralCalculator.ST_ambient = this.converterParaFloat(this.flangeIntegralCalculator.sfo);

            //Smax Ambient
            this.flangeIntegralCalculator.Smax_ambient = this.converterParaFloat(this.flangeIntegralCalculator.sfo);

            //SH ambient 1 ---- Ok
            if (this.flangeIntegralCalculator.bSelect == 0) {
                this.flangeIntegralCalculator.SH_ambient_1 = this.converterParaFloat(((this.flangeIntegralCalculator.fShape * this.flangeIntegralCalculator.Matm) / ((this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.thicknessHubBack, 2) * this.flangeIntegralCalculator.idFlange))).toFixed(4));
            } else {
                this.flangeIntegralCalculator.SH_ambient_1 = this.converterParaFloat(((this.flangeIntegralCalculator.fShape * this.flangeIntegralCalculator.Matm) / ((this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.thicknessHubBack, 2) * this.flangeIntegralCalculator.b1))).toFixed(4));
            }

            //SR ambient 1 ---- Ok
            this.flangeIntegralCalculator.SR_ambient_1 = this.converterParaFloat(((this.flangeIntegralCalculator.beta * this.flangeIntegralCalculator.Matm) / (this.flangeIntegralCalculator.L * Math.pow(this.flangeIntegralCalculator.t, 2) * this.flangeIntegralCalculator.idFlange)).toFixed(4));

            //ST ambient 1 ---- Ok
            this.flangeIntegralCalculator.ST_ambient_1 = this.converterParaFloat((((this.flangeIntegralCalculator.Y * this.flangeIntegralCalculator.Matm) / (Math.pow(this.flangeIntegralCalculator.t, 2) * this.flangeIntegralCalculator.idFlange)) - (this.flangeIntegralCalculator.Z * this.flangeIntegralCalculator.SR_ambient_1)).toFixed(4));

            //Smax ambient 1 ---- Ok
            this.flangeIntegralCalculator.Smax_ambient_1 = this.converterParaFloat((Math.max(
                0.5 * (this.flangeIntegralCalculator.SH_ambient_1 + this.flangeIntegralCalculator.SR_ambient_1),
                0.5 * (this.flangeIntegralCalculator.SH_ambient_1 + this.flangeIntegralCalculator.ST_ambient_1)
            )).toFixed(4));

            //SH ambient 2 --- Ok
            this.flangeIntegralCalculator.SH_ambient_2 = this.converterParaFloat((1.5 * this.flangeIntegralCalculator.sfa).toFixed(4));

            //SR ambient 2 --- Ok
            this.flangeIntegralCalculator.SR_ambient_2 = this.converterParaFloat(this.flangeIntegralCalculator.sfa);

            //ST ambient 2 ---- Ok
            this.flangeIntegralCalculator.ST_ambient_2 = this.converterParaFloat(this.flangeIntegralCalculator.sfa);

            //Smax ambient 2 ---- Ok
            this.flangeIntegralCalculator.Smax_ambient_2 = this.converterParaFloat(this.flangeIntegralCalculator.sfa);


            //Bolting
            //Torque Mínimo
            //=MÁXIMO(((G38*G47*E36*0,0254)/E37);((G38*G44*E36*0,0254)/E37))
            this.flangeIntegralCalculator.torqueMinimo = this.converterParaFloat(Math.max(
                ((this.flangeIntegralCalculator.frictionFactor * this.flangeIntegralCalculator.Wm1 * this.flangeIntegralCalculator.boltDiameter * 0.0254) / this.flangeIntegralCalculator.boltsQuantity),
                ((this.flangeIntegralCalculator.frictionFactor * this.flangeIntegralCalculator.Wm2 * this.flangeIntegralCalculator.boltDiameter * 0.0254) / this.flangeIntegralCalculator.boltsQuantity)
            ).toFixed(0));
            //Torque Máximo
            //= G38*K48*E36*0,0254/E37
            this.flangeIntegralCalculator.torqueMaximo = this.converterParaFloat(((this.flangeIntegralCalculator.frictionFactor * this.flangeIntegralCalculator.W * this.flangeIntegralCalculator.boltDiameter * 0.0254) / this.flangeIntegralCalculator.boltsQuantity).toFixed(0));
            
            //Gasket
            //Ag
            //=3,141516*((E40^2)-(E41^2))/4
            this.flangeIntegralCalculator.Ag = this.converterParaFloat((3.141516 * (Math.pow(this.flangeIntegralCalculator.odGasket, 2) - Math.pow(this.flangeIntegralCalculator.idGasket, 2))) / 4).toFixed(2);
            //Sya
            //=K47/H40
            this.flangeIntegralCalculator.Sya = this.converterParaFloat((this.flangeIntegralCalculator.W2 / this.flangeIntegralCalculator.Ag).toFixed(2));
            //Sys
            //=MÍNIMO(E42;H41)
            this.flangeIntegralCalculator.Sys = this.converterParaFloat(Math.min(this.flangeIntegralCalculator.Sya, this.flangeIntegralCalculator.gasketCrushingPressure).toFixed(2));
            //campo sem nome 1
            //=SE(E(H40*E42>K48;H41*H40>K48);1;0)
            if ((this.flangeIntegralCalculator.Ag * this.flangeIntegralCalculator.gasketCrushingPressure > this.flangeIntegralCalculator.W) &&
                (this.flangeIntegralCalculator.Sya * this.flangeIntegralCalculator.Ag > this.flangeIntegralCalculator.W)) {
                this.flangeIntegralCalculator.valorCampoSemNome1 = 1;
            } else {
                this.flangeIntegralCalculator.valorCampoSemNome1 = 0;
            }
            //unidade campo sem nome 1
            //=SE(I40=0;"Sym<W";"Sym>W")
            this.flangeIntegralCalculator.unidadeCampoSemNome1 = this.flangeIntegralCalculator.valorCampoSemNome1 == 0 ? "Sym<W" : "Sym>W";
            
            //Campo sem nome 2
            //=SE(G47<K48;1;0)
            this.flangeIntegralCalculator.valorCampoSemNome2 = this.flangeIntegralCalculator.Wm1 < this.flangeIntegralCalculator.W ? 1 : 0;
            //Unidade campo sem nome 2
            //=SE(I41=0;"Wm1>W";"Wm1<W")
            this.flangeIntegralCalculator.unidadeCampoSemNome2 = this.flangeIntegralCalculator.valorCampoSemNome2 == 0 ? "Wm1>W" : "Wm1<W";
            //mensagem Gasket
            //=SE(I40*I41=1;"Combinação parafuso/junta satisfatória";"combinação parafuso/junta insatisfatória")
            this.flangeIntegralCalculator.resultGasket = (this.flangeIntegralCalculator.valorCampoSemNome1 * this.flangeIntegralCalculator.valorCampoSemNome2) == 1 ?
                "Combinação parafuso/junta satisfatória" : "combinação parafuso/junta insatisfatória";


            //Flange
            //Mensagem G1
            //=SE(E24<(20*E28);"B<20g1, se quiser substituir por B1ver celula A2";"B>20g1")
            if (this.flangeIntegralCalculator.idFlange < (20 * this.flangeIntegralCalculator.thicknessHubBack)) {
                this.flangeIntegralCalculator.mensagemG1 = "B<20g1, se quiser substituir por B1, selecionar na pré configuração";
            } else {
                this.flangeIntegralCalculator.mensagemG1 = "B>20g1";
            }
            //Mensagem f
            //=SE(E31<=1;"B=B1+g1";"B1=B+g0")
            this.flangeIntegralCalculator.mensagemF = this.flangeIntegralCalculator.f <= 1 ? "B=B1+g1" : "B1=B+g0";
            //Mensagem B1
            //=SE(E2=1;"Será utilizado para calcular SH";"Não será utilizado p/ calcular SH")
            this.flangeIntegralCalculator.mensagemB1 = this.flangeIntegralCalculator.bSelect == 1 ? "Será utilizado para calcular SH" : "Não será utilizado p/ calcular SH";





        },
        converterParaFloat(valor) {
            if (valor === "" || valor === null || valor === undefined) {
                return 0;
            }

            const valorString = valor.toString().trim();
            const valorSemEspacos = valorString.replace(/\s+/g, "");
            let valorNormalizado = valorSemEspacos;

            if (valorSemEspacos.includes(",") && valorSemEspacos.includes(".")) {
                const ultimoPonto = valorSemEspacos.lastIndexOf(".");
                const ultimaVirgula = valorSemEspacos.lastIndexOf(",");
                const separadorDecimal = ultimaVirgula > ultimoPonto ? "," : ".";
                const separadorMilhar = separadorDecimal === "," ? "." : ",";

                valorNormalizado = valorSemEspacos
                    .replace(new RegExp(`\\${separadorMilhar}`, "g"), "")
                    .replace(separadorDecimal, ".");
            } else if (valorSemEspacos.includes(",")) {
                valorNormalizado = valorSemEspacos.replace(/,/g, ".");
            }

            const valorConvertido = parseFloat(valorNormalizado);
            return isNaN(valorConvertido) ? 0 : valorConvertido;
        },
    },
};
</script>

<style>
.material-table {
    overflow: visible !important;
}

.material-options {
    max-height: 280px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 100%;
    left: 0;
    z-index: 9999;
    border: 1px solid #d7e0ed;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(23, 32, 51, 0.14);
}

.material-option {
    cursor: pointer;
    color: #334e73;
    padding: 11px 14px;
    white-space: normal;
}

.material-option:hover,
.material-option:focus {
    background-color: #edf4ff;
    color: #0056ff;
}

    .col-symbol {
        width: 50px !important;
        text-align: center;
    }
    .texto-azul, .texto-vermelho{
        font-weight: bold;
        font-size: 20px;
    }
    .texto-azul{
        color: blue;
    }
    .texto-vermelho {
        color: red;
    }

    /* WIDTH DOS INPUTS */
    input, select {
        min-width: 100px;
    }
</style>